import { createRootRouteWithContext } from '@tanstack/react-router';

import type { AppConfig } from '../config';
import { RootComponent } from './RootComponent';

export interface RouterContext {
  config: AppConfig;
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
